<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Type" >
                                        <select class="form-control" size="large" v-model="inputType">
                                            <option v-for="option in typeOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row" v-if="site_type == 'ho'">
                                <div class="col-md-7">
                                    <base-input label="Location">
                                        <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" changeOnSelect/>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortBy" :disabled="isShow == false">
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showAdvancedInfoDiv' > 
                                        {{showAdvancedInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                                    </button>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Display onhand">
                                        <select class="form-control" size="large" v-model="inputDisplay">
                                            <option v-for="option in displayOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <base-checkbox class="mb-3" v-model="isShow">
                                Show Details
                            </base-checkbox>
        
                            <base-checkbox class="mb-3" v-model="isSeparateSite">
                                Separate Per Site
                            </base-checkbox>
        
                            <base-checkbox class="mb-3" v-model="isConsider">
                                Consider Transfer In as part of receiving 
                            </base-checkbox>
        
                            <base-checkbox class="mb-3" v-model="isContent" :disabled="isShow == false">
                                Show Content Quantity
                            </base-checkbox>
                            <div class="row">
                                <div class="col-md-7">
                                    <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                        {{toggleLabel}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils, { dissectReportFilters } from '../../components/reportUtils';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import {
        mapState,
        mapActions
    } from 'vuex'
import { getReportDescription } from '../../utilities';
    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputGroupBy: 'supplier_id',
                groupOptions: [
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'}
                ],
                inputSortBy: 'product_id',
                sortOptions: [
                    {key: 'product_id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'onhand_qty', value: 'Sub Total'},
                    {key: 'rr_date', value: 'Last Arrival Date'}
                ],
                inputType: '1',
                typeOptions: [
                    {key: '1', value: 'Weekly'},
                    {key: '2', value: 'Monthly'},
                    {key: '3', value: 'Quarterly'}
                ],
                inputDisplay: '1',
                displayOptions: [
                    {key: '1', value: 'All items regarless of onhand quantity'},
                    {key: '2', value: 'All items with onhand quantity only'},
                    {key: '3', value: 'All items with zero onhand quantity only'},
                    {key: '4', value: 'All items with negative onhand quantity only'},
                    {key: '5', value: 'All items with negative or zero onhand quantity'},
                    {key: '6', value: 'All items with positive or zero onhand quantity'},
                    {key: '6', value: 'All items except those with zero quantity'},
                ],
                birSalesReports: [],

                currDate: moment().format("L_LT").split(":").join(";"),
                showAdvancedInfo: 'asc',
                isShow: true,
                isSeparateSite: false,
                isConsider: false,
                isContent: false,
                JsonData: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,
                accessRights:[],
                accessCostPriceRights:[],
                reportDescription: '',
                inputLocation: [],
                locationOptions: []
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);
            
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = getReportDescription(this.currentProfile)
            this.accessRights = this.$attrs.access_rights || []
            this.accessCostPriceRights = this.$attrs.access_costprice_rights || []
        },
        computed: {
            ...mapState(['currentProfile','endPoint']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        watch: {
            isShow: function() {
               if(this.isShow == false){
                   this.isContent = false
               }
            }
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showAdvancedInfoDiv(){
                this.showAdvancedInfo == 'asc' ? this.showAdvancedInfo = 'desc' : this.showAdvancedInfo = 'asc'
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            diffDays(date1, date2){
                let a = moment(date1,'YYYY-MM-DD');
                let b = moment(date2,'YYYY-MM-DD');
                return b.diff(a, 'days');
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            async onLocationChange(){
                var location = this.inputLocation[this.inputLocation.length - 1]
                if(!location){
                    this.handleClearInputLocation()
                }else {
                    this.siteOptions = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                    this.inputSite = this.siteOptions.map( s => s.id);
                }
                
            },
            async handleClearInputLocation() {
                    var userId = secureStorage.getItem("userId");
                    var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                    this.siteOptions = sites;
                    this.sort(this.siteOptions);
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
                    let siteId = secureStorage.getItem("defaultSiteId");
                    this.inputSite = [siteId]
            },
            generateReport: async function () {
                this.spinning= true;
                let as_of = moment().format('MMMM DD, YYYY')
                let group_val = this.groupOptions.find(x => x.key === this.inputGroupBy).value

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "group": this.inputGroupBy,
                    "order": this.inputSortBy,
                    "by": this.showAdvancedInfo,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "type": this.inputType,
                    "isTI": this.isConsider,
                    "isShow": this.isShow,
                    "advanced_filter": this.params
                }
                let get_request = await HTTPRequest.getRequest(this.endPoint + 'inventory_aging?', parameters);

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    let doc = []
                    if(this.isShow == true){
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2' });
                    } else {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    }

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    let header_top = [];
                    let header_detail = [];
                    
                    let header_text = "Week"
                    if(this.inputType == '2'){
                        header_text = "Month"
                    } else if(this.inputType == '3'){
                        header_text = "Quarter"
                    }
                    
                    if(this.isShow == true){
                        header_top.push(
                            {content: 'Product\nCode', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Barcode', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Stock No', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'Description', rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'SRP', rowSpan: 2, styles: {halign: 'center'}}
                        )

                        if(this.isContent == true){
                            header_top.push(
                                {content: 'Content Qty', rowSpan: 2, styles: {halign: 'center'}}
                            )
                        }
                    } else {
                        header_top.push(
                            {content: group_val, rowSpan: 2, styles: {halign: 'center'}},
                            {content: 'SRP', rowSpan: 2, styles: {halign: 'center'}}
                        )
                    }

                    header_top.push(
                        {content: `1 ${header_text} old`, rowSpan: 2, styles: {halign: 'center'}},
                        {content: `2 ${header_text} old`, rowSpan: 2, styles: {halign: 'center'}},
                        {content: `3 ${header_text} old`, rowSpan: 2, styles: {halign: 'center'}},
                        {content: `4 ${header_text} and\nolder`, rowSpan: 2, styles: {halign: 'center'}},
                        {content: 'Sub Total', rowSpan: 2, styles: {halign: 'center'}},
                    )

                    let doc_text = 'RR'
                    if(this.isConsider == true){
                        doc_text = 'RR/STI'
                    }

                    if(this.isShow == true){
                        header_top.push(
                            {content: 'Oldest Doc', colSpan: 2, styles: {halign: 'center'}},
                            {content: `Last ${doc_text} Document`, colSpan: 3, styles: {halign: 'center'}},
                            {content: 'Last Sale\nDate', rowSpan: 2, styles: {halign: 'center'}}
                        )

                        header_detail.push(
                            {content: 'Date', styles: {halign: 'center'}},
                            {content: 'Aging', styles: {halign: 'center'}},
                            {content: 'Date', styles: {halign: 'center'}},
                            {content: 'Quantity', styles: {halign: 'center'}},
                            {content: 'Cost', styles: {halign: 'center'}}
                        )
                    } else {
                        header_top.push(
                            {content: `Last ${doc_text} Document`, styles: {halign: 'center'}}
                        )

                        header_detail.push(
                            {content: 'Quantity', styles: {halign: 'center'}}
                        )
                    }

                    headers = [header_top, header_detail]

                    let grand_col1 = 0
                    let grand_col2 = 0
                    let grand_col3 = 0
                    let grand_col4 = 0
                    let grand_rr_qty = 0

                    let assortment = 0

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let sub_col1 = 0
                            let sub_col2 = 0
                            let sub_col3 = 0
                            let sub_col4 = 0
                            let sub_rr_qty = 0

                            let total_col1 = 0
                            let total_col2 = 0
                            let total_col3 = 0
                            let total_col4 = 0
                            let total_rr_qty = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                assortment = reportLine.product_count
                                let grouper_name = reportLine.grouper_name
                                
                                if(this.isShow == true){
                                    if(grouper == 'start'){
                                        let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.grouper_id){
                                            let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.grouper_id
                                }
                                
                                let subtotal = Number(reportLine.col_1) + Number(reportLine.col_2) + 
                                    Number(reportLine.col_3) + Number(reportLine.col_4)

                                let onhand = Number(reportLine.onhand_qty)
                                let rem = onhand

                                let col1_display = Number(reportLine.col_1)
                                let col2_display = Number(reportLine.col_2)
                                let col3_display = Number(reportLine.col_3)
                                let col4_display = Number(reportLine.col_4)
                                if(subtotal > rem){
                                    if(col1_display >= rem){
                                        col1_display = rem
                                        col2_display = 0
                                        col3_display = 0
                                        col4_display = 0
                                    } else {
                                        rem -= col1_display
                                        if(col2_display >= rem) {
                                            col2_display = rem
                                            col3_display = 0
                                            col4_display = 0
                                        } else {
                                            rem -= col2_display
                                            if(col3_display >= rem) {
                                                col3_display = rem
                                                col4_display = 0
                                            } else {
                                                rem -= col3_display
                                                col4_display = rem
                                            }
                                        }
                                    }
                                } else {
                                    let excess = rem - subtotal
                                    col4_display += excess
                                }

                                let subtotal_display = col1_display + col2_display + col3_display + col4_display

                                let as_of_date = moment().format('YYYY-MM-DD')
                                let no_days_display = ''
                                if(reportLine.old_date != null){
                                    let no_days = this.diffDays(reportLine.old_date, as_of_date)
                                    no_days_display = this.formatNumber(Number(no_days))
                                }

                                let rr_date = ''
                                let rr_qty = ''
                                let rr_cost = ''
                                if(reportLine.rr_date != null){
                                    rr_date = reportLine.rr_date
                                    rr_cost = this.convertToCurrency(Number(reportLine.rr_cost))
                                }

                                if(Number(reportLine.rr_qty) > 0){
                                    rr_qty = this.convertToCurrency(Number(reportLine.rr_qty))
                                }

                                let detail = []
                                total_col1 += col1_display
                                total_col2 += col2_display
                                total_col3 += col3_display
                                total_col4 += col4_display
                                total_rr_qty += Number(reportLine.rr_qty)

                                sub_col1 += col1_display
                                sub_col2 += col2_display
                                sub_col3 += col3_display
                                sub_col4 += col4_display
                                sub_rr_qty += Number(reportLine.rr_qty)

                                grand_col1 += col1_display
                                grand_col2 += col2_display
                                grand_col3 += col3_display
                                grand_col4 += col4_display
                                grand_rr_qty += Number(reportLine.rr_qty)

                                if(this.isShow == true){
                                    detail.push(
                                        reportLine.product_id,
                                        reportLine.barcode,
                                        reportLine.stock_no,
                                        {content: reportLine.name, styles: {halign: 'left'}},
                                        this.convertToCurrency(Number(reportLine.retail_price))
                                    )   
                                    if(this.isContent == true){
                                        detail.push(
                                            this.convertToCurrency(Number(reportLine.content_quantity))
                                        )
                                    }
                                    detail.push( 
                                        this.convertToCurrency(col1_display),
                                        this.convertToCurrency(col2_display),
                                        this.convertToCurrency(col3_display),
                                        this.convertToCurrency(col4_display),
                                        this.convertToCurrency(subtotal_display),
                                        reportLine.old_date,
                                        no_days_display,
                                        rr_date,
                                        rr_qty,
                                        this.addMaskValidation(rr_cost, 'Z'),
                                        reportLine.sales_date
                                    )
                                } else {
                                    detail.push(
                                        {content: reportLine.grouper_name, styles: {halign: 'left'}},
                                        '',
                                        this.convertToCurrency(col1_display),
                                        this.convertToCurrency(col2_display),
                                        this.convertToCurrency(col3_display),
                                        this.convertToCurrency(col4_display),
                                        this.convertToCurrency(subtotal_display),
                                        rr_qty
                                    )
                                }
                                
                                reportData.push(Object.assign({}, detail))

                                let sub_subtotal = sub_col1 + sub_col2 + sub_col3 + sub_col4
                                if(i == this.birSalesReports.length-1){
                                    let total_detail = []
                                    let sub_detail = []

                                    let total_subtotal = total_col1 + total_col2 + total_col3 + total_col4
                                    let total_display = "Grand Total"
                                    if(this.isSeparateSite == true){
                                        total_display = "Site Sub Total"
                                    }

                                    if(this.isSeparateSite == false){
                                        total_detail.push(
                                            {content: `Assortment : ${assortment}`, styles: {halign: 'left'}}
                                        )
                                    } else {
                                        total_detail.push('')
                                    }

                                    if(this.isShow == true){
                                        total_detail.push(
                                            "", "", `${total_display} :`, ""
                                        )
                                        sub_detail.push(
                                            "", "", "",
                                            "Sub Total :", ""
                                        )
                                        
                                        if(this.isContent == true){
                                            total_detail.push("")
                                            sub_detail.push("")
                                        }
                                        total_detail.push( 
                                            this.convertToCurrency(total_col1),
                                            this.convertToCurrency(total_col2),
                                            this.convertToCurrency(total_col3),
                                            this.convertToCurrency(total_col4),
                                            this.convertToCurrency(total_subtotal),
                                            '', '', '', this.convertToCurrency(total_rr_qty), "", ""
                                        )

                                        sub_detail.push( 
                                            this.convertToCurrency(sub_col1),
                                            this.convertToCurrency(sub_col2),
                                            this.convertToCurrency(sub_col3),
                                            this.convertToCurrency(sub_col4),
                                            this.convertToCurrency(sub_subtotal),
                                            '', '', '', this.convertToCurrency(sub_rr_qty), "", ""
                                        )

                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))
                                        
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, total_detail))
                                    } else {
                                        total_detail.push(
                                            `${total_display} :`,
                                            this.convertToCurrency(total_col1),
                                            this.convertToCurrency(total_col2),
                                            this.convertToCurrency(total_col3),
                                            this.convertToCurrency(total_col4),
                                            this.convertToCurrency(total_subtotal),
                                            this.convertToCurrency(total_rr_qty)
                                        )

                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, total_detail))
                                    }
                                } else {
                                    if(this.isShow == true){
                                        let current_grouper = reportLine.grouper_id
                                        let next_grouper = this.birSalesReports[i+1].grouper_id

                                        if(current_grouper != next_grouper){
                                            let sub_detail = []

                                            sub_detail.push(
                                                "", "",
                                                "Sub Total :", ""
                                            )

                                            if(this.isContent == true){
                                                sub_detail.push("")
                                            }

                                            sub_detail.push( 
                                                this.convertToCurrency(sub_col1),
                                                this.convertToCurrency(sub_col2),
                                                this.convertToCurrency(sub_col3),
                                                this.convertToCurrency(sub_col4),
                                                this.convertToCurrency(sub_subtotal),
                                                '', '', '', this.convertToCurrency(sub_rr_qty), "", ""
                                            )

                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, sub_detail))

                                            sub_col1 = 0
                                            sub_col2 = 0
                                            sub_col3 = 0
                                            sub_col4 = 0
                                            sub_rr_qty = 0
                                        }
                                    }
                                }
                            }
                        }

                        if(x == siteSpecific.length-1 && this.isSeparateSite == true){
                            let total_detail = []

                            let grand_subtotal = grand_col1 + grand_col2 + grand_col3 + grand_col4

                            if(this.isShow == true){
                                total_detail.push(
                                    {content: `Assortment : ${assortment}`, styles: {halign: 'left'}}, "", "",
                                    `Grand Total :`, ""
                                )
                                
                                if(this.isContent == true){
                                    total_detail.push("")
                                }

                                total_detail.push( 
                                    this.convertToCurrency(grand_col1),
                                    this.convertToCurrency(grand_col2),
                                    this.convertToCurrency(grand_col3),
                                    this.convertToCurrency(grand_col4),
                                    this.convertToCurrency(grand_subtotal),
                                    '', '', '', this.convertToCurrency(grand_rr_qty), "", ""
                                )
                            } else {
                                total_detail.push(
                                    {content: `Assortment : ${assortment}`, styles: {halign: 'left'}},
                                    `Grand Total :`,
                                    this.convertToCurrency(grand_col1),
                                    this.convertToCurrency(grand_col2),
                                    this.convertToCurrency(grand_col3),
                                    this.convertToCurrency(grand_col4),
                                    this.convertToCurrency(grand_subtotal),
                                    this.convertToCurrency(grand_rr_qty)
                                )
                            }

                            reportData.push(Object.assign({}, ["rowLine"]))
                            reportData.push(Object.assign({}, total_detail))
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + group_val
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Inventory Aging Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        doc.text(15,25,"As of " + as_of)
                        let design_x = 580
                        let design_y = 400
                        if(this.isShow == false){
                            design_x = 340
                            design_y = 200
                        }

                        if(this.isSeparateSite == true){
                            // doc.text(340,20,siteSpecific[x].report_details[0].site_name,"right");
                            doc.text(15, 30, `Site/s: ${siteSpecific[x].report_details[0].site_name}`)
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(15, 30, `Site/s: ${site_text}`)
                            // doc.text(340,20,site_text,"right");
                        }
                        let filterText = dissectReportFilters(parameters, this.displayOptions, this.formatOptions)
                        const {basic, advance} = filterText
                        doc.text(15, 35, `Filter/s: ${basic}`)
                        if (Object.keys(parameters.advanced_filter).length !== 0) {
                            doc.text(15, 40, `Product Filter/s: ${advance}`)
                        }

                        let colStyles = {}
                        if(this.isShow == false){
                            colStyles = {
                                0: {cellWidth: 95},
                                1: {cellWidth: 30},
                                2: {cellWidth: 30},
                                3: {cellWidth: 30},
                                4: {cellWidth: 30},
                                5: {cellWidth: 30},
                                6: {cellWidth: 30},
                                7: {cellWidth: 50}
                            }
                        } else {
                            let name_width = 110
                            if(this.isContent == false){
                                name_width = 140
                            }
                            colStyles = {
                                0: {cellWidth: 28},
                                1: {cellWidth: 28},
                                2: {cellWidth: 28},
                                3: {cellWidth: name_width},
                                4: {cellWidth: 28},
                                5: {cellWidth: 28},
                                6: {cellWidth: 28},
                                7: {cellWidth: 28},
                                8: {cellWidth: 28},
                                9: {cellWidth: 28},
                                10: {cellWidth: 28},
                                11: {cellWidth: 28},
                                12: {cellWidth: 28},
                                13: {cellWidth: 28},
                                14: {cellWidth: 28},
                                15: {cellWidth: 28},
                                16: {cellWidth: 28}
                            }
                        }
                        

                        doc.autoTable({
                            // startY: 35, 
                            startY: Object.keys(this.params).length !== 0? 45 : 40,
                            head: headers, 
                            body: reportData, 
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: {bottom: 25},
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[3] == 'Grand Total :' || data.row.raw[3] == 'Site Sub Total :' || data.row.raw[1] == 'Grand Total :' || data.row.raw[1] == 'Site Sub Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Inventory Aging Report" + group_text, design_x, design_y, i, pageCount)
                        }
                        
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Inventory_Aging_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                let as_of = moment().format('MMMM DD, YYYY')
                let group_val = this.groupOptions.find(x => x.key === this.inputGroupBy).value

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "group": this.inputGroupBy,
                    "order": this.inputSortBy,
                    "by": this.showAdvancedInfo,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "type": this.inputType,
                    "isTI": this.isConsider,
                    "isShow": this.isShow,
                    "advanced_filter": this.params
                }
                let get_request = await HTTPRequest.getRequest(this.endPoint + 'inventory_aging?', parameters);

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                if(get_request.length > 0){
                    let doc = []
                    let headers = [];
                    let header_top = [];
                    let header_detail = [];
                    let site_specific = [];
                    
                    let header_text = "Week"
                    if(this.inputType == '2'){
                        header_text = "Month"
                    } else if(this.inputType == '3'){
                        header_text = "Quarter"
                    }
                    
                    if(this.isShow == true){
                        header_top.push('Product Code','Barcode', 'Stock No','Description','SRP')

                        if(this.isContent == true){
                            header_top.push('Content Qty')
                        }
                    } else {
                        header_top.push(group_val,'SRP')
                    }

                    header_top.push(`1 ${header_text} old`,`2 ${header_text} old`,`3 ${header_text} old`,`4 ${header_text} and\nolder`,'Sub Total')

                    let doc_text = 'RR'
                    if(this.isConsider == true){
                        doc_text = 'RR/STI'
                    }

                    if(this.isShow == true){
                        header_top.push('Oldest Doc Date','Oldest Doc Aging',`Last ${doc_text} Document Date`,`Last ${doc_text} Document Quantity`,`Last ${doc_text} Document Cost`,'Last Sale Date')
                    } else {
                        header_top.push(`Last ${doc_text} Document`)

                        header_detail.push('Quantity')
                    }

                    headers = header_top 

                    let grand_col1 = 0
                    let grand_col2 = 0
                    let grand_col3 = 0
                    let grand_col4 = 0
                    let grand_rr_qty = 0

                    let assortment = 0

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let sub_col1 = 0
                            let sub_col2 = 0
                            let sub_col3 = 0
                            let sub_col4 = 0
                            let sub_rr_qty = 0

                            let total_col1 = 0
                            let total_col2 = 0
                            let total_col3 = 0
                            let total_col4 = 0
                            let total_rr_qty = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                assortment = reportLine.product_count
                                let grouper_name = reportLine.grouper_name
                                
                                if(this.isShow == true){
                                    if(grouper == 'start'){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.grouper_id){
                                            let detail_header = [grouper_name];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.grouper_id
                                }
                                
                                let subtotal = Number(reportLine.col_1) + Number(reportLine.col_2) + 
                                    Number(reportLine.col_3) + Number(reportLine.col_4)

                                let onhand = Number(reportLine.onhand_qty)
                                let rem = onhand

                                let col1_display = Number(reportLine.col_1)
                                let col2_display = Number(reportLine.col_2)
                                let col3_display = Number(reportLine.col_3)
                                let col4_display = Number(reportLine.col_4)
                                if(subtotal > rem){
                                    if(col1_display >= rem){
                                        col1_display = rem
                                        col2_display = 0
                                        col3_display = 0
                                        col4_display = 0
                                    } else {
                                        rem -= col1_display
                                        if(col2_display >= rem) {
                                            col2_display = rem
                                            col3_display = 0
                                            col4_display = 0
                                        } else {
                                            rem -= col2_display
                                            if(col3_display >= rem) {
                                                col3_display = rem
                                                col4_display = 0
                                            } else {
                                                rem -= col3_display
                                                col4_display = rem
                                            }
                                        }
                                    }
                                } else {
                                    let excess = rem - subtotal
                                    col4_display += excess
                                }

                                let subtotal_display = col1_display + col2_display + col3_display + col4_display

                                let as_of_date = moment().format('YYYY-MM-DD')
                                let no_days_display = ''
                                if(reportLine.old_date != null){
                                    let no_days = this.diffDays(reportLine.old_date, as_of_date)
                                    no_days_display = this.formatNumber(Number(no_days))
                                }

                                let rr_date = ''
                                let rr_qty = ''
                                let rr_cost = ''
                                if(reportLine.rr_date != null){
                                    rr_date = reportLine.rr_date
                                    rr_cost = this.convertToCurrency(Number(reportLine.rr_cost))
                                }

                                if(Number(reportLine.rr_qty) > 0){
                                    rr_qty = this.convertToCurrency(Number(reportLine.rr_qty))
                                }

                                let detail = []
                                total_col1 += col1_display
                                total_col2 += col2_display
                                total_col3 += col3_display
                                total_col4 += col4_display
                                total_rr_qty += Number(reportLine.rr_qty)

                                sub_col1 += col1_display
                                sub_col2 += col2_display
                                sub_col3 += col3_display
                                sub_col4 += col4_display
                                sub_rr_qty += Number(reportLine.rr_qty)

                                grand_col1 += col1_display
                                grand_col2 += col2_display
                                grand_col3 += col3_display
                                grand_col4 += col4_display
                                grand_rr_qty += Number(reportLine.rr_qty)

                                if(this.isShow == true){
                                    detail.push(
                                        reportLine.product_id,
                                        reportLine.barcode,
                                        reportLine.stock_no, reportLine.name,
                                        this.convertToCurrency(Number(reportLine.retail_price))
                                    )
                                    if(this.isContent == true){
                                        detail.push(
                                            this.convertToCurrency(Number(reportLine.content_quantity))
                                        )
                                    }
                                    detail.push( 
                                        this.convertToCurrency(col1_display),
                                        this.convertToCurrency(col2_display),
                                        this.convertToCurrency(col3_display),
                                        this.convertToCurrency(col4_display),
                                        this.convertToCurrency(subtotal_display),
                                        reportLine.old_date,
                                        no_days_display,
                                        rr_date,
                                        rr_qty,
                                        this.addMaskValidation(rr_cost, 'Z'),
                                        reportLine.sales_date
                                    )
                                } else {
                                    detail.push(reportLine.grouper_name,
                                        '',
                                        this.convertToCurrency(col1_display),
                                        this.convertToCurrency(col2_display),
                                        this.convertToCurrency(col3_display),
                                        this.convertToCurrency(col4_display),
                                        this.convertToCurrency(subtotal_display),
                                        rr_qty
                                    )
                                }
                                
                                reportData.push(Object.assign({}, detail))

                                let sub_subtotal = sub_col1 + sub_col2 + sub_col3 + sub_col4
                                if(i == this.birSalesReports.length-1){
                                    let total_detail = []
                                    let sub_detail = []

                                    let total_subtotal = total_col1 + total_col2 + total_col3 + total_col4
                                    let total_display = "Grand Total"
                                    if(this.isSeparateSite == true){
                                        total_display = "Site Sub Total"
                                    }

                                    if(this.isSeparateSite == false){
                                        total_detail.push(`Assortment : ${assortment}`)
                                    } else {
                                        total_detail.push('')
                                    }

                                    if(this.isShow == true){
                                        total_detail.push(
                                            "", `${total_display} :`, ""
                                        )
                                        sub_detail.push(
                                            "", "",
                                            "Sub Total :", ""
                                        )
                                        
                                        if(this.isContent == true){
                                            total_detail.push("")
                                            sub_detail.push("")
                                        }
                                        total_detail.push( 
                                            this.convertToCurrency(total_col1),
                                            this.convertToCurrency(total_col2),
                                            this.convertToCurrency(total_col3),
                                            this.convertToCurrency(total_col4),
                                            this.convertToCurrency(total_subtotal),
                                            '', '', '', this.convertToCurrency(total_rr_qty), "", ""
                                        )

                                        sub_detail.push( 
                                            this.convertToCurrency(sub_col1),
                                            this.convertToCurrency(sub_col2),
                                            this.convertToCurrency(sub_col3),
                                            this.convertToCurrency(sub_col4),
                                            this.convertToCurrency(sub_subtotal),
                                            '', '', '', this.convertToCurrency(sub_rr_qty), "", ""
                                        )

                                        reportData.push(Object.assign({}, sub_detail))
                                        
                                        reportData.push(Object.assign({}, total_detail))
                                    } else {
                                        total_detail.push(
                                            `${total_display} :`,
                                            this.convertToCurrency(total_col1),
                                            this.convertToCurrency(total_col2),
                                            this.convertToCurrency(total_col3),
                                            this.convertToCurrency(total_col4),
                                            this.convertToCurrency(total_subtotal),
                                            this.convertToCurrency(total_rr_qty)
                                        )

                                        reportData.push(Object.assign({}, total_detail))
                                    }
                                } else {
                                    if(this.isShow == true){
                                        let current_grouper = reportLine.grouper_id
                                        let next_grouper = this.birSalesReports[i+1].grouper_id

                                        if(current_grouper != next_grouper){
                                            let sub_detail = []

                                            sub_detail.push(
                                                "", "",
                                                "Sub Total :", ""
                                            )

                                            if(this.isContent == true){
                                                sub_detail.push("")
                                            }

                                            sub_detail.push( 
                                                this.convertToCurrency(sub_col1),
                                                this.convertToCurrency(sub_col2),
                                                this.convertToCurrency(sub_col3),
                                                this.convertToCurrency(sub_col4),
                                                this.convertToCurrency(sub_subtotal),
                                                '', '', '', this.convertToCurrency(sub_rr_qty), "", ""
                                            )

                                            reportData.push(Object.assign({}, sub_detail))

                                            sub_col1 = 0
                                            sub_col2 = 0
                                            sub_col3 = 0
                                            sub_col4 = 0
                                            sub_rr_qty = 0
                                        }
                                    }
                                }
                            }
                        }

                        if(x == siteSpecific.length-1 && this.isSeparateSite == true){
                            let total_detail = []

                            let grand_subtotal = grand_col1 + grand_col2 + grand_col3 + grand_col4

                            if(this.isShow == true){
                                total_detail.push(`Assortment : ${assortment}`, "", "",
                                    `Grand Total :`, ""
                                )
                                
                                if(this.isContent == true){
                                    total_detail.push("")
                                }

                                total_detail.push( 
                                    this.convertToCurrency(grand_col1),
                                    this.convertToCurrency(grand_col2),
                                    this.convertToCurrency(grand_col3),
                                    this.convertToCurrency(grand_col4),
                                    this.convertToCurrency(grand_subtotal),
                                    '', '', '', this.convertToCurrency(grand_rr_qty), "", ""
                                )
                            } else {
                                total_detail.push(`Assortment : ${assortment}`,
                                    `Grand Total :`,
                                    this.convertToCurrency(grand_col1),
                                    this.convertToCurrency(grand_col2),
                                    this.convertToCurrency(grand_col3),
                                    this.convertToCurrency(grand_col4),
                                    this.convertToCurrency(grand_subtotal),
                                    this.convertToCurrency(grand_rr_qty)
                                )
                            }

                            reportData.push(Object.assign({}, total_detail))
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + group_val
                        }
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Inventory Aging Report" + group_text, "Generate By: " + printed_by,"As of " + as_of])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;
                        let newJsonData=[];
                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'error', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            }
        }
    };
</script>

<style></style>